// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".external-link-icon-module__externalLinkContainer__2q1G3{display:flex;justify-content:center;align-items:baseline}.external-link-icon-module__externalLinkContainer__2q1G3:hover{text-decoration:none}.external-link-icon-module__externalLinkContent__37loD:hover{text-decoration:underline}.external-link-icon-module__icon__1PE5R{opacity:0;max-width:0;transition:transform 0.3s ease-in-out, max-width 0.3s ease-in-out, opacity 0.3s linear, margin-left 0.3s ease-in-out}.external-link-icon-module__externalLinkContainer__2q1G3:hover .external-link-icon-module__icon__1PE5R{opacity:1;max-width:15px;margin-left:0.5rem}\n", ""]);
// Exports
exports.locals = {
	"externalLinkContainer": "external-link-icon-module__externalLinkContainer__2q1G3",
	"externalLinkContent": "external-link-icon-module__externalLinkContent__37loD",
	"icon": "external-link-icon-module__icon__1PE5R"
};
module.exports = exports;
